
import React from 'react'
import { Button, Modal, NewTable } from '../../../../components'
import { mapTableRows } from '../../../../utils';


const AvalableCreditsModal = ({ open, onClose }) => {

  const tableData = [
    {
      CreditMemo:"Unapplied Payment",
      CreditAvailable:"9640.00",
      PatmentDate:"07/27/2021"
    },
    {
      CreditMemo:"Unapplied Payment",
      CreditAvailable:"9640.00",
      PatmentDate:"07/27/2021"
    },
    {
      CreditMemo:"Unapplied Payment",
      CreditAvailable:"9640.00",
      PatmentDate:"07/27/2021"
    },
    {
      CreditMemo:"Unapplied Payment",
      CreditAvailable:"9640.00",
      PatmentDate:"07/27/2021"
    },
    {
      CreditMemo:"Unapplied Payment",
      CreditAvailable:"9640.00",
      PatmentDate:"07/27/2021"
    },

  ]
  const columns = [

    {
      key: "CreditMemo",
      label: "Credit Memo",
    },
    {
      key: "CreditAvailable",
      label: "Credit Available",
    },
    {
      key: "PatmentDate",
      label: "Patment Date",
    }
  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="AVALABLE CREDITS"
      width="max-w-7xl"
    >
      <div>
        <NewTable
          showCheckbox
          rows={mappedRows}
          columns={columns}
          hideToolBar
        />
        <div className="flex justify-end mt-2">
          <Button title={"close"} variant="contained" onClick={onClose} />
        </div>
      </div>
    </Modal>
  )
}

export default AvalableCreditsModal
